export const PROJECT_TYPE_IDS = {
    report: '647bbf15-c72a-4cdc-bace-464c5368e325',
    approval: '80e0e031-4932-466d-93c5-107ffd361218',
};

export const TO_DO_LIST_COLORS = {
    eventOpen: '#ff9f00',
    eventClosed: '#1ebead',
    buttonDelete: 'red',
    buttonReopenEvent: '#ff9f00',
    buttonCloseEvent: '#1ebead',
};

export const TO_DO_LIST_OVERVIEW_ROLES = [
    'it',
    'super',
    'management',
];

export const TOP_MANAGEMENT_FILTER = {
    'alif': {
        report: [
            '6cb9bc24-606e-46cd-a17b-740398fbf5d7', // Draft Report Final being review by Pak Alif
            'a036fab4-31a8-4410-bc8a-20d2536724e2' // Prelim advise being review by Pak Alif (new)
        ],
        approval: [
            'afb9821f-6ed1-4bdc-820b-ee24d3fa136f' // Draft Approval being review by Pak Alif
        ],
    },
    'fauzi': {
        report: [
            '7ab80398-7935-4991-b32f-88df52cf3cbe', // Draft Report Final being review by Pak Fauzi
            '5deeae51-c568-492f-9627-203e1e54309a', // Prelim advise being review by Pak Fauzi (new)
        ],
        approval: [
            'd5d44fe1-4606-4543-af6b-93a940be9b06' // Draft Approval being review by Pak Fauzi
        ],
    },
    'faishal': {
        report: [
            'eb9d6839-dd62-450e-8c96-435d96e05be8', // Draft Report being review by Pak Faishal
            '999a9793-e7b7-11ef-8bf1-cffc7f893362', // Draft Report Final being review by Pak Faishal
            '999a9307-e7b7-11ef-8bf1-cffc7f893362' // Prelim advise being review by Pak Faishal (new)
        ],
        approval: [],
    },
};

export const PROJECT_EXPENSES_DEFAULT_LIST = {
    survey: [
        'Flight Ticket',
        'Taxi/Local Transport',
        'Hotel',
        'Communication Expenses',
        'Allowance (X days)'
    ]
};

export const MULTIPLE_SUMMARY_OF_COST_DEFAULT_LIST = [
    'Salvage',
    'Temporary Repair',
    'Towing',
    'Repair',
    'Replace (untuk Engine / Propulsi)',
    'General Service',
];

export const DEFAULT_PROJECTS_EXPORT_COLUMNS_LIST = [
    'project_number', 'case_type', 'vessel_name', 'vessel_type', 'project_type', 'project_type_detail', 'casualty_type',
    // 'surveyor', 'admin', 'final_reviewer', 'project_status', 'instruction_by', 'instructor', 'issued_date', 
    // 'latest_comment', 'place_of_repair', 'repairs', 'project_summary', 'date_of_accident', 'date_survey_status',
    // 'broker', 'shipowner', 'adjuster', 'pa_issued_date', 'report_date_issued', 'date_hard_copy', 'letter_issued_date', 
];

export const PROJECTS_EXPORT_COLUMNS_LIST = [
    { key: 'project_number', label: 'Project Number' },
    { key: 'case_type', label: 'Case Type' },
    { key: 'vessel_name', label: 'Vessel Name' },
    { key: 'vessel_type', label: 'Vessel Type' },
    { key: 'project_type', label: 'Project Type' },
    { key: 'project_type_detail', label: 'Project Type Detail' },
    { key: 'casualty_type', label: 'Casualty Type' },
    { key: 'instruction_by', label: 'Instruction By' },
    { key: 'instructor', label: 'Instructor' },
    { key: 'surveyor', label: 'Surveyor' },
    { key: 'admin', label: 'Admin' },
    { key: 'final_reviewer', label: 'Final Reviewer' },
    { key: 'project_status', label: 'Project Status' },
    { key: 'issued_date', label: 'Issued Date' },
    { key: 'latest_comment', label: 'Latest Comment' },
    { key: 'place_of_repair', label: 'Place of Repair' },
    { key: 'repairs', label: 'Repairs' },
    { key: 'project_summary', label: 'Project Summary' },
    { key: 'date_of_accident', label: 'Date of Accident' },
    { key: 'date_survey_status', label: 'Date Survey Status' },

    { key: 'broker', label: 'Broker' },
    { key: 'shipowner', label: 'Shipowner' },
    { key: 'adjuster', label: 'Adjuster' },
    { key: 'pa_issued_date', label: 'PA Issued Date' },
    { key: 'report_date_issued', label: 'Report Date Issued' },
    { key: 'date_hard_copy', label: 'Date Hard Copy' },
    { key: 'letter_issued_date', label: 'Letter Issued Date' },
];

export const DEFAULT_INVOICES_EXPORT_COLUMNS_LIST = [
    'project_number', 'share_percentage', 'status_invoice', 'project_type', 'vessel_name',  'invoice_number', 'casualty', 'client',
    // 'total_invoice', 'expense_changes', 'total_usd', 'total_idr', 'date_issued', 'remarks', 
    // 'tax_invoice_number', 'vat_amount', 'date_of_tax_23', 'tax_23', 'pph_23_status', 'bank_receiver', 'cash_date', 'case_amount', 
    // 'payment_date_usd', 'total_amount_usd', 'payer_usd', 'payment_date_idr', 'total_amount_idr', 'payer_idr', 'outstanding_usd', 'outstanding_idr',
];

export const INVOICES_EXPORT_COLUMNS_LIST = [
    { key: 'project_number', label: 'Case Number' },
    { key: 'share_percentage', label: 'Share Invoice' },
    { key: 'status_invoice', label: 'Invoice Status' },
    { key: 'project_type', label: 'Project Type' },
    { key: 'vessel_name', label: 'Vessel Name' },
    { key: 'casualty', label: 'Casualty' },
    { key: 'client', label: 'Client Name' },
    { key: 'invoice_number', label: 'Invoice Number' },
    { key: 'total_invoice', label: 'Total Invoice' },
    { key: 'expense_changes', label: 'Expense Changes' },
    { key: 'total_usd', label: 'Total USD' },
    { key: 'total_idr', label: 'Total IDR' },
    { key: 'date_issued', label: 'Date Issued' },
    { key: 'tax_invoice_number', label: 'Tax Invoice Number' },
    { key: 'vat_amount', label: 'VAT Amount' },
    { key: 'date_of_tax_23', label: 'Date of Tax 23' },
    { key: 'tax_23', label: 'Tax 23' },
    { key: 'pph_23_status', label: 'PPH 23 Status' },
    { key: 'bank_receiver', label: 'Bank Receiver' },
    { key: 'cash_date', label: 'Cash Date' },
    { key: 'case_amount', label: 'Case Amount' },
    { key: 'payment_date_usd', label: 'Payment Date USD' },
    { key: 'total_amount_usd', label: 'Total Amount USD' },
    { key: 'payer_usd', label: 'Payer USD' },
    { key: 'payment_date_idr', label: 'Payment Date IDR' },
    { key: 'total_amount_idr', label: 'Total Amount IDR' },
    { key: 'payer_idr', label: 'Payer IDR' },
    { key: 'remarks', label: 'Remarks' },
    { key: 'outstanding_usd', label: 'Outstanding USD' },
    { key: 'outstanding_idr', label: 'Outstanding IDR' },
];

export default {
    PROJECT_TYPE_IDS,
    TO_DO_LIST_COLORS,
    TO_DO_LIST_OVERVIEW_ROLES,
    DEFAULT_PROJECTS_EXPORT_COLUMNS_LIST,
    PROJECTS_EXPORT_COLUMNS_LIST,
    INVOICES_EXPORT_COLUMNS_LIST,
};